import React, {useEffect} from 'react';
import $ from "../../utils/datatables";
import {Link} from "react-router-dom";
import { toast } from 'react-toastify';
import {GET_TRADE_OFFERS_URL} from "../../api";

const TradeOffer = (props) => {

    const token = localStorage.getItem('jwtToken');

    useEffect(() => {
        let table = $('#trade_offer_table').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Loading trade offers</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                $.ajax(GET_TRADE_OFFERS_URL, {
                    type: 'GET',
                    headers: {
                        Authorization: token
                    },
                    success: function(res) {
                        const rawList = Array.isArray(res) ? res : (res?.results ?? res?.data ?? []);
                        const result = rawList.map((item) => ({ raw: item }));

                        callback({
                            recordsTotal: res?.count ?? result.length,
                            recordsFiltered: res?.count ?? result.length,
                            data: result
                        });
                    },
                    error: function(err) {
                        toast.error(err.statusText || 'Failed to load trade offers', {position: "top-right", autoClose: 5000});
                        callback({ recordsTotal: 0, recordsFiltered: 0, data: [] });
                    }
                });
            },
            columns: [
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" }
            ],
            columnDefs: [
                {
                    render: function(data) {
                        const agg = data?.aggregator;
                        return (agg?.name ?? agg?.pacra_id ?? '—');
                    },
                    targets: 0
                },
                {
                    render: function(data) {
                        const crop = data?.crop;
                        return (crop?.name ?? crop ?? '—');
                    },
                    targets: 1
                },
                {
                    render: function(data) {
                        const town = data?.town;
                        return (town?.name ?? town ?? '—');
                    },
                    targets: 2
                },
                {
                    render: function(data) {
                        const statusMap = {
                            OPEN: '<span class="badge bg-success text-white">Open</span>',
                            NEGOTIATION: '<span class="badge bg-warning text-dark">Negotiation</span>',
                            ACCEPTED: '<span class="badge bg-info text-white">Accepted</span>',
                            CLOSED: '<span class="badge bg-dark text-white">Closed</span>'
                        };
                        return statusMap[data?.status] ?? (data?.status ?? '—');
                    },
                    targets: 3
                },
                {
                    render: function(data) {
                        const typeMap = {
                            OPEN: 'Open Market',
                            DIRECT: 'Direct Offer'
                        };
                        return typeMap[data?.offer_type] ?? (data?.offer_type ?? '—');
                    },
                    targets: 4
                },
                {
                    render: function(data) {
                        const qty = data?.standard_available_quantity ?? data?.quantity;
                        const units = data?.units ?? 'kg';
                        return qty != null ? `${Number(qty).toLocaleString()} ${units}` : '—';
                    },
                    targets: 5
                },
                {
                    render: function(data) {
                        return data?.price != null ? Number(data.price).toLocaleString() : '—';
                    },
                    targets: 6
                },
                {
                    render: function(data) {
                        return `<a href="#" class="nav-link view_trade_offer"><i class="fa fa-eye"></i> View offer</a>`;
                    },
                    targets: 7
                }
            ]
        });

        table.on('click', '.view_trade_offer', function(e) {
            e.preventDefault();
            let rowData = table.row($(this).closest('tr')).data();
            if (rowData && rowData.raw && rowData.raw.id) {
                props.history.push(`/trade_offer/${rowData.raw.id}`);
            }
            return false;
        });
    }, [props.history, token]);

    const reloadTable = () => {
        if ($.fn.DataTable.isDataTable('#trade_offer_table')) {
            $('#trade_offer_table').DataTable().ajax.reload(null, false);
        }
    };

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Trade Offers</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Trade Offers</h4>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Trade Offers</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="trade_offer_table" className="table table-hover" style={{width: "100%"}}>
                                    <thead>
                                        <tr>
                                            <th className="wd-12p">Aggregator</th>
                                            <th className="wd-12p">Crop</th>
                                            <th className="wd-12p">Town</th>
                                            <th className="wd-10p">Status</th>
                                            <th className="wd-10p">Type</th>
                                            <th className="wd-10p">Qty Available</th>
                                            <th className="wd-10p">Price</th>
                                            <th className="wd-10p">Action</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TradeOffer;
